import React, { useState } from "react";
import styled from "styled-components";
import { userInformation } from "./data";
import { FipayLogo, Footer, PageTitle } from "./PaymentInfo.styled";
import { useFormik, useFormikContext } from "formik";
import { brandSettings } from "../../store/nanostore";
import { useStore } from "@nanostores/react";
import { numberOnly, numberOnlyWithCallback } from "../../utils/input";

interface UserInfoProps {
  handleNext: (step: number) => void;
}

function UserInfo({ handleNext }: UserInfoProps) {
  const { handleChange, values, handleSubmit, isSubmitting, isValid } =
    useFormikContext();
  const $brandSettings = useStore(brandSettings);

  return (
    <UserInfoWrapper>
      <PageTitle $small>Enter user information</PageTitle>
      <UserInfoForm>
        {userInformation.map((info) => (
          <Label key={info.label}>
            <LabelSpan>{info.label}</LabelSpan>
            {info.label === "Phone Number" ? (
              <UserInputContainer>
                <UserInfoInput1 type="tel" placeholder="+1" disabled />
                <UserInfoInput2
                  {...info}
                  type="number"
                  onChange={handleChange}
                  onInput={numberOnlyWithCallback(
                    ({ target }: any) => target.value?.length <= 11
                  )}
                  value={(values as any)?.[info.name]}
                  pattern="^\d{11}$"
                />
              </UserInputContainer>
            ) : (
              <UserInfoInput
                {...info}
                type={info.type}
                value={(values as any)?.[info.name]}
                onChange={handleChange}
              />
            )}
          </Label>
        ))}
        <PayBtn1
          backgroundColor={$brandSettings?.primaryColor}
          color={$brandSettings?.secondaryColor}
          onClick={handleSubmit as any}
          $active={!isSubmitting && isValid}
        >
          {isSubmitting ? "Saving" : "Next"}
        </PayBtn1>
      </UserInfoForm>
      <Footer>
        Secured by <FipayLogo />
      </Footer>
    </UserInfoWrapper>
  );
}

export default UserInfo;

const UserInfoWrapper = styled.div`
  width: 70%;
  margin-top: 1rem;
  padding: 1rem 0;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  box-sizing: border-box;
`;

const UserInputContainer = styled.div`
  display: flex;
  gap: 0.5rem;
  width: 100%;
`;

const UserInfoForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  display: flex;
  justify-content: center;
  padding-top: 10px;
  width: 100%;
  height: fit-content;
  padding-right: 0.5rem;
`;

const Label = styled.label``;

const UserInfoInput = styled.input`
  border: 1px solid #e8eaed;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
  width: 99%;
  height: 2.5rem;
  background: #ffffff;
  border-radius: 15px;
  text-indent: 15px;
  margin-top: 1rem;
  font-size: 16px;
  font-weight: 400;

  &:focus {
    outline: none;
  }
`;

const UserInfoInput2 = styled.input`
  border: 1px solid #e8eaed;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  height: 2.5rem;
  background: #ffffff;
  border-radius: 15px;
  text-indent: 15px;
  margin-top: 1rem;
  margin-bottom: 4rem;
  font-size: 16px;
  font-weight: 400;

  &:focus {
    outline: none;
  }
`;

const UserInfoInput1 = styled.input`
  border: 1px solid #e8eaed;
  height: 30px;
  text-indent: 14px;
  padding: 8px;
  width: 12%;
  border-radius: 15px;
  margin-top: 1rem;
  font-size: 16px;
  height: 1.7rem;
  color: #b9b8b8;

  &:focus {
    outline: none;
  }

  @media (max-width: 768px) {
    text-indent: 2px;
  }
`;

const UserInfoSpan = styled.span``;

const LabelSpan = styled.span`
  font-family: GT Walsheim Pro;
  font-weight: 500;
  font-size: 14px;
  color: #363636;
`;

export const PayBtn1 = styled.button<{
  $active?: boolean;
  backgroundColor?: string;
  color?: string;
  css?: string;
}>`
  padding: 0.5rem 0;
  border-radius: 0.625rem;
  font-size: 1rem;
  font-weight: 500;
  color: ${({ color }) => color || "#fff"};
  background: ${({ backgroundColor }) => backgroundColor || "#00a603"};
  border: 1px solid white;
  opacity: ${({ $active }) => ($active ? 1 : 0.3)};
  cursor: ${({ $active }) => ($active ? "pointer" : "not-allowed")};

  transition: opacity 0.3s ease;
  ${({ css }) => css || ""}
`;
